module.exports = __webpack_public_path__ + "static/media/Passport Front.ba5bebea.jpg";